async function transformer(response) {
  return Promise.resolve(response);
}

export default transformer;
